import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { WfAvatarService } from 'wflow-ui';
import { UserIdentityAPIService } from 'wflow-main-app/src/app/core/api';
import { selectCurrentOrganizationId } from '../../store/organizations/organizations.selectors';

@Injectable({
  providedIn: 'root',
})
export class AvatarService implements WfAvatarService {
  private readonly userIdentitySvc = inject(UserIdentityAPIService);
  private readonly store = inject(Store);

  getMyAvatarUrl(): Observable<string | null> {
    return this.userIdentitySvc.getMyAvatarBlob().pipe(map(this.toAvatarUrl));
  }

  getAvatarUrl(login: string): Observable<string | null> {
    return this.store.select(selectCurrentOrganizationId).pipe(
      take(1),
      switchMap((orgId) =>
        orgId ? this.userIdentitySvc.getUserAvatarBlob(orgId, login) : of(null),
      ),
      map(this.toAvatarUrl),
    );
  }

  deleteAvatar(): Observable<void> {
    return this.userIdentitySvc.deleteAvatar();
  }

  uploadAvatar(avatar: Blob): Observable<void> {
    return this.userIdentitySvc.uploadAvatar(avatar);
  }

  // SVG avatars can carry <script>; opening the blob URL directly executes it.
  // Drop them at display time so legacy SVGs already in the DB stop rendering.
  private toAvatarUrl(blob: Blob | null): string | null {
    if (!blob || blob.type.startsWith('image/svg')) {
      return null;
    }
    return URL.createObjectURL(blob);
  }
}
